"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FieldSelectCompact = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importStar(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const lodash_uniqueid_1 = __importDefault(require("lodash.uniqueid"));
const smartlabel_1 = __importDefault(require("../../smartlabel/smartlabel"));
const select_1 = __importDefault(require("../../select/select"));
const status_1 = require("../../constants/status");
class FieldSelectCompact extends react_1.default.PureComponent {
    constructor() {
        super(...arguments);
        this.state = {
            inputHasFocus: false
        };
        this.id = lodash_uniqueid_1.default('fslctc_');
        this.handleFocus = () => {
            this.setState({
                inputHasFocus: true
            });
        };
        this.handleBlur = () => {
            this.setState({
                inputHasFocus: false
            });
        };
        this.handleChange = e => {
            this.props.onValueChange(e);
        };
        this.render = () => {
            const { children, label, selectRef, valid, modified, invalid, caution, disabled } = this.props;
            const { inputHasFocus } = this.state;
            const inputHasValue = !!react_1.Children.toArray(this.props.children).find(option => option.props.selected === true);
            let status;
            if (invalid) {
                status = status_1.STATUS_INVALID;
            }
            else if (caution) {
                status = status_1.STATUS_CAUTION;
            }
            else if (valid) {
                status = status_1.STATUS_VALID;
            }
            else if (modified) {
                status = status_1.STATUS_MODIFIED;
            }
            else {
                status = null;
            }
            const labelProps = {
                forId: this.id,
                text: label,
                inputHasValue,
                inputHasFocus,
                status
            };
            const selectProps = {
                placeholder: label,
                id: this.id,
                onFocus: this.handleFocus,
                onBlur: this.handleBlur,
                onChange: this.handleChange,
                status,
                selectRef,
                disabled
            };
            return (jsx_runtime_1.jsx(smartlabel_1.default, Object.assign({}, labelProps, { children: jsx_runtime_1.jsx(select_1.default, Object.assign({}, selectProps, { children: children }), void 0) }), void 0));
        };
    }
}
exports.FieldSelectCompact = FieldSelectCompact;
FieldSelectCompact.propTypes = {
    children: prop_types_1.default.node.isRequired,
    label: prop_types_1.default.string.isRequired,
    onValueChange: prop_types_1.default.func.isRequired,
    selectRef: prop_types_1.default.func,
    invalid: prop_types_1.default.bool,
    caution: prop_types_1.default.bool,
    valid: prop_types_1.default.bool,
    modified: prop_types_1.default.bool,
    disabled: prop_types_1.default.bool
};
FieldSelectCompact.defaultProps = {
    selectRef: () => { },
    invalid: false,
    caution: false,
    valid: false,
    modified: false,
    disabled: false
};
exports.default = FieldSelectCompact;
//# sourceMappingURL=field.select.compact.js.map